import { render, staticRenderFns } from "./CompanyOwnershipForm.vue?vue&type=template&id=aa92a0a8"
import script from "./CompanyOwnershipForm.vue?vue&type=script&lang=ts"
export * from "./CompanyOwnershipForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports